import React from 'react'
import Link from 'gatsby-link'
import { Container } from 'react-responsive-grid'

import { rhythm, scale } from '../utils/typography'

import logo from "../logo.svg"

import "prismjs/themes/prism.css";

class Template extends React.Component {
  render() {
    const { location, children, data } = this.props
    const siteTitle = data.site.siteMetadata.title
    let header

    let rootPath = `/`
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`
    }

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
              display: "flex",
              alignItems: "center"
            }}
            to={'/'}
          >
            <span
              style={{
                width: "2em",
                height: "2em",
                backgroundImage: `url(${logo})`,
                backgroundSize: "contain",
                backgroundPosition: "50%",
                backgroundRepeat: "no-repeat"
              }} />
            {siteTitle}
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3
          style={{
            marginTop: 0,
            marginBottom: rhythm(-1),
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit',
              display: "flex",
              alignItems: "center"
            }}
            to={'/'}
          >
            <span
              style={{
                width: "2em",
                height: "2em",
                backgroundImage: `url(${logo})`,
                backgroundSize: "contain",
                backgroundPosition: "50%",
                backgroundRepeat: "no-repeat"
              }} />
            {siteTitle}
          </Link>
        </h3>
      )
    }
    return (
      <Container
        style={{
          maxWidth: rhythm(35),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
        {header}
        {children()}
      </Container>
    )
  }
}

export default Template

export const query = graphql`
  query LayoutQuery {
    site {
      siteMetadata {
        title
      }
    }
  }`



// WEBPACK FOOTER //
// ./src/layouts/index.js